import React from "react";
import "./CenteredLayout.scss";

export function CenteredLayout(props: any) {
	return <div className="centered-layout">{props.children}</div>;
}
